import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as FilterIcon } from './icons/icon-filter.svg';

export interface IFilterButton {
    isLoading?: boolean;
    openFiltersDialog: () => void;
    selectedFilterCount: number;
    title: string;
}

const useStyles = makeStyles({
    filterButton: {
        background: '#E8EAF4',
        borderRadius: '0.5rem',
        height: '2.875rem',
        padding: '0.75rem 1.5rem',
        display: 'flex',
        boxSizing: 'border-box',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        transition: '0.15s ease-in-out',
        '&:hover': {
            background: '#DFE2EA',
        },
        '&:active': {
            background: '#DADCE4',
        },
        '& > span > svg': {
            marginRight: '0.625rem',
            fill: '#C1CAE1',
            width: '0.875rem',
            height: '0.875rem',
            '& > path': {
                fill: '#C1CAE1',
            },
        },
        '& > p': {
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '1rem',
            lineHeight: '1.375rem',
            display: 'flex',
            alignItems: 'center',
            color: '#616161',
            '& > span': {
                marginLeft: '0.5rem',
            },
        },
        '& p': {
            margin: '0',
        },
    },
    appliedFilters: {
        background: '#FFFCE6 !important',
        border: '1px solid #FFDD02 !important',
        borderRadius: '0.5rem !important',
        '& > span > svg': {
            fill: '#FFDD02!important',
            '& > path': {
                fill: '#FFDD02 !important',
            },
        },
    },
});

const FilterButton = (props: IFilterButton) => {
    const { selectedFilterCount, openFiltersDialog, title } = props;
    const classes = useStyles();

    return (
        <Button
            className={`${selectedFilterCount > 0 ? classes.appliedFilters : undefined} ${classes.filterButton}`}
            onClick={openFiltersDialog}
            data-component-name="FILTER_BUTTON"
        >
            <FilterIcon />

            <p>
                {title}{' '}
                {selectedFilterCount > 0 && <span style={{ margin: '0 0.25rem' }}>({selectedFilterCount})</span>}
            </p>
        </Button>
    );
};

FilterButton.defaultProps = {
    title: 'Filters',
} as Partial<IFilterButton>;

export default FilterButton;
